import billingLogo1 from "../../../assets/icons/billingLogo1.png";
import billingLogo2 from "../../../assets/icons/billingLogo2.png";
import billingLogo3 from "../../../assets/icons/billingLogo3.png";
import billingLogo4 from "../../../assets/icons/billingLogo4.png";
import billingLogo5 from "../../../assets/icons/billingLogo5.png";
import billingLogo6 from "../../../assets/icons/billingLogo6.png";
import billingLogo7 from "../../../assets/icons/billingLogo7.png";
import billingLogo8 from "../../../assets/icons/billingLogo8.png";
import billingLogo9 from "../../../assets/icons/billingLogo9.png";
import billingLogo10 from "../../../assets/icons/billingLogo10.png";
import billingLogo11 from "../../../assets/icons/billingLogo11.png";
import billingLogo12 from "../../../assets/icons/billingLogo12.png";
import billingLogo13 from "../../../assets/icons/billingLogo13.png";
import billingLogo14 from "../../../assets/icons/billingLogo14.png";
import billingLogo15 from "../../../assets/icons/billingLogo15.png";
import billingLogo16 from "../../../assets/icons/billingLogo16.png";
const BillingCardData = [
  {
    id: 1,
    logo: billingLogo1,
    title: "Multi POS billing solution",
  },
  {
    id: 2,
    logo: billingLogo2,
    title: "Create & customize invoices",
  },
  {
    id: 3,
    logo: billingLogo3,
    title: "Minimize frauds & improve security",
  },

  {
    id: 4,
    logo: billingLogo4,
    title: "Issue debit note & credit note",
  },
  {
    id: 5,
    logo: billingLogo5,
    title: "Ledger outstanding & ledger summary",
  },
  {
    id: 6,
    logo: billingLogo6,
    title: "Generate multiple billing report",
  },
  {
    id: 7,
    logo: billingLogo7,
    title: "Multiple payment options",
  },
  {
    id: 8,
    logo: billingLogo8,
    title: "Customer records creation",
  },
  {
    id: 9,
    logo: billingLogo9,
    title: "Multiple currency & language support",
  },
  {
    id: 10,
    logo: billingLogo10,
    title: "Recurring billing solution",
  },
  {
    id: 11,
    logo: billingLogo11,
    title: "Renting bill solution",
  },
  {
    id: 12,
    logo: billingLogo12,
    title: "GST complied invoicing",
  },
  {
    id: 13,
    logo: billingLogo13,
    title: "GST return related reports generation",
  },
  {
    id: 14,
    logo: billingLogo14,
    title: "World wide tax compliance",
  },
  {
    id: 15,
    logo: billingLogo15,
    title: "Wallet / Virtual / Member card billing solution",
  },
  {
    id: 16,
    logo: billingLogo16,
    title: "Barcode & QSR code support",
  },
];

export default BillingCardData;
